import script from "./SearchComp.vue?vue&type=script&setup=true&lang=js"
export * from "./SearchComp.vue?vue&type=script&setup=true&lang=js"

import "./SearchComp.vue?vue&type=style&index=0&id=70a67c6a&lang=scss"

const __exports__ = script;

export default __exports__